import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
export var Input = /*#__PURE__*/ forwardRef(function Input(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _label = _param.label, label = _label === void 0 ? "" : _label, _description = _param.description, description = _description === void 0 ? "" : _description, _errorMessage = _param.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage, rest = _object_without_properties(_param, [
        "className",
        "label",
        "description",
        "errorMessage"
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-3",
        children: [
            label && /*#__PURE__*/ _jsx("label", {
                className: "block font-medium opacity-60",
                children: label
            }),
            description && /*#__PURE__*/ _jsx("label", {
                className: "block font-medium text-sm opacity-50",
                children: description
            }),
            /*#__PURE__*/ _jsx("input", _object_spread({
                ref: ref,
                type: "text",
                style: {
                },
                className: clsx("w-full text-gray-900 rounded-lg p-2 px-3 transition-shadow font-medium tracking-wide", "border-gray-300 block bg-gray-50 focus:ring-2 ring-gray-300 dark:ring-gray-600 focus:ring-gray-400", "focus:!outline-none", "dark:text-white dark:placeholder-gray-400", "dark:focus:ring-gray-500 ring-1 ", "dark:border-gray-600 dark:bg-gray-700", className)
            }, rest)),
            errorMessage && /*#__PURE__*/ _jsx("div", {
                className: "font-medium text-sm dark:text-red-300 text-red-500",
                children: errorMessage
            })
        ]
    });
});
